<template>
  <div id="app">
    <Header :user="user" :lang="lang" :isMobileDevice="isMobileDevice" @toggleLanguage="toggleLanguage"/>
    <router-view :user="user" :lang="lang" :isMobileDevice="isMobileDevice"/>
    <Footer v-if="lang == 'ko'"/>
    <Footer_En v-else-if="lang == 'en'"/>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Footer_En from '@/components/FooterEn.vue'
import { mapState } from 'vuex'
//
export default {
  name: 'App',
  components: {
    Header, Footer, Footer_En
  },
  data() {
    return {
      lang: 'ko',
      isMobileDevice: false
    }
  },
  computed: {
    ...mapState(['user']),
  },
  created() {
    document.title = (process.env.NODE_ENV == 'production'? '' : '[개발용]') + '주식회사 엠쓰리시스템즈';
    this.lang = navigator.language.indexOf('ko') >= 0? 'ko' : 'en';
    // 현행화된 모바일 감지 로직 - DeclanKim 2025.11.27.sprint1
    // 1. userAgent 기반 감지 (가장 신뢰도 높음)
    const userAgent = navigator.userAgent.toLowerCase();
    const mobileKeywords = ['android', 'webos', 'iphone', 'ipad', 'ipod', 'blackberry', 'windows phone'];
    const isMobileUA = mobileKeywords.some(keyword => userAgent.includes(keyword));
    
    // 2. 터치 지원 여부 확인
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    
    // 3. 화면 크기 기반 감지 (1024px 이하)
    const isSmallScreen = window.innerWidth <= 1024;
    
    // 4. platform 확인 (ARM64 포함)
    const platform = navigator.platform.toLowerCase();
    const desktopPlatforms = ['win32', 'win64', 'windows', 'mac', 'macintel', 'linux x86_64', 'linux armv8l'];
    const isPlatformDesktop = desktopPlatforms.some(p => platform.includes(p));
    
    // 종합 판단: userAgent 우선, 보조적으로 터치+화면크기 사용
    if (isMobileUA) {
      this.isMobileDevice = true;
    } else if (!isPlatformDesktop && isTouchDevice && isSmallScreen) {
      this.isMobileDevice = true;
    } else {
      this.isMobileDevice = false;
    }
    // var filter = "win16|win32|win64|mac|macintel";
    // if (navigator.platform) {
    //     // mobile 접속
    //     if (filter.indexOf(navigator.platform.toLowerCase()) < 0) {
    //         this.isMobileDevice = true;
    //     }
    //     // pc 접속
    //     else {
    //         this.isMobileDevice = false;
    //     }
    // }


    const lang = localStorage.getItem('lang');
    if(lang) {
        this.lang = lang;
    }
  },

  
  methods: {
    toggleLanguage(language) {
      this.lang = language;
      localStorage.setItem('lang', language);
    }
  }
}
</script>

<style>
:root {
  --main-color: #000137;
  --sub-color: #B1DBF1;
}
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>
